import { render, staticRenderFns } from "./CreateDocsTemplate.vue?vue&type=template&id=6d602289&scoped=true"
import script from "./CreateDocsTemplate.vue?vue&type=script&lang=js"
export * from "./CreateDocsTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateDocsTemplate.vue?vue&type=style&index=0&id=6d602289&prod&scoped=true&lang=css"
import style1 from "./CreateDocsTemplate.vue?vue&type=style&index=1&id=6d602289&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d602289",
  null
  
)

export default component.exports